<template>
  <div class="mit-borrow-key-page mit-page">
      <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card">
            <v-card-title>Borrow Keys</v-card-title>
            <v-card-subtitle class="caption">Borrow CSAIL keys</v-card-subtitle>

            <v-divider></v-divider>
            <v-stepper v-if="!wizard.complete" v-model="wizard.step" alt-labels>
              <v-stepper-header>
                <v-stepper-step :complete="wizard.step > 1" step="1">Select User</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="wizard.step > 2" step="2">Assign Keys</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="3">Review</v-stepper-step>
              </v-stepper-header>
              <v-divider></v-divider>
              <v-stepper-items>
                <v-stepper-content step="1">
                    <v-container>
                      <v-form ref="formUser" lazy-validation>
                        <v-autocomplete
                          color="primary"
                          label="Select User"
                          v-model="wizard.formData.selectedUser"
                          :items="userList"
                          :search-input.sync="userSearch"
                          :loading="wizard.formData.usersloading"
                          item-text="id"
                          return-object
                          no-data-text="Enter text to get users..."
                          outlined
                          v-on:change="userSelectedEvent"
                          v-on:update:search-input="userSelectInputChangeEvent"
                        >
                            <template v-slot:item="data">
                                <v-list-item-content>
                                  <v-list-item-title>{{data.item.id}}</v-list-item-title>
                                  <v-list-item-subtitle>{{data.item.email}}</v-list-item-subtitle>
                                  <v-list-item-subtitle>{{data.item.name}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </template>
                        </v-autocomplete>
                      </v-form>
                    </v-container>
                  <div class="wizard-actions">
                    <v-btn disabled>Back</v-btn>
                    <v-btn :disabled="wizard.formData.selectedUser == ''" class="ml-3" color="primary" @click="wizard.step = 2">Next</v-btn>
                  </div>
                  <div v-if="wizard.formData.selectedUser !== ''">
                    <br><br>
                    <p style="color:gray;">Currently Borrowed Keys:</p>
                    <v-data-table
                      class="elevation-0"
                      :headers="currentBorrowedListHeaders.items"
                      :items="currentBorrowedList.items"
                      sort-by="keyName"
                      :hide-default-footer="true"
                      :disable-pagination="true"
                    >
                    <template v-slot:item.spaces="{ item }">
                      <MitKeySpaces :dark="false" size="small" :spaces="item.spacesDisplay" :spacesDetails="item.spaces"/>
                    </template>
                  </v-data-table>
                  </div>
                </v-stepper-content>

                <v-stepper-content step="2">
                    <!-- <v-container> -->
                      <v-form ref="formKeys" class="pa-5">

                        <v-row>
                          <v-col class="mit-available-keys" cols="12" lg="5" md="6" sm="6" xs="12">
                              <v-row class="pt-5">
                                <p class="pr-5"><b>Available Keys</b></p>
                              </v-row>
                              <v-row class="pb-5">
                                <v-text-field
                                  class="search-text"
                                  v-model="wizard.formData.keySearchTerm"
                                  append-icon="mdi-magnify"
                                  label="Search"
                                  single-line hide-details></v-text-field>
                              </v-row>

                              <v-data-table
                                height="400px"
                                fixed-header
                                :single-select="true"
                                v-model="wizard.formData.selectedKeyList"
                                :headers="[
                                  {text: 'Name',align: 'start',sortable: true,value: 'name',width: '10%'},
                                  {text: 'Available',sortable: false,value: 'numberAvailable', width: '10%'},
                                  {text: 'Spaces',sortable: false,value: 'spacesDisplay'},
                                  {text: 'Notes', sortable: false, value: 'data.notes', width: '15%'}
                                ]"
                                :items="keyList"
                                :search="wizard.formData.keySearchTerm"
                                sort-by="name"
                                class="elevation-0"
                                :hide-default-footer="true"
                                :disable-pagination="true"
                              >
                                    <template v-slot:item="{ item, isSelected, select }">
                                        <!-- HACK ALERT: below DIV is needed.
                                        Not sure why but removing this div causes the first item to not display select, like something is overriding the first item style somehow... -->
                                        <div></div>
                                        <tr :class="isSelected?'mit-row-selected':''" @click="toggleSelectedKey(isSelected,select,$event)">
                                            <td>{{item.name}}</td>
                                            <td>{{item.numberAvailable}}</td>
                                            <td>
                                              <MitKeySpaces :search="{text:wizard.formData.keySearchTerm}" :dark="true" size="small" :spaces="item.spacesDisplay" :spacesDetails="item.spaces"/>
                                            </td>
                                            <td>{{item.data.notes}}</td>
                                        </tr>
                                    </template>
                                </v-data-table>
                          </v-col>
                          <v-col cols="2" md="2" sm="2" xs="12">
                              <v-row class="pb-10 pt-15" align="center" justify="center">
                                <v-btn :disabled="wizard.formData.selectedKeyList.length <= 0" @click="addToSelectedKeys"><v-icon>mdi-arrow-right-bold</v-icon></v-btn><br>
                              </v-row>
                              <v-row align="center" justify="center">
                                <v-btn :disabled="wizard.formData.selectedBorrowList == null" @click="removeFromSelectedKeys"><v-icon>mdi-arrow-left-bold</v-icon></v-btn>
                              </v-row>
                          </v-col>
                          <v-col class="mit-selected-keys" cols="5" md="4" sm="4" xs="12">
                              <p class="pt-1"><b>Selected Keys</b></p>
                              <v-divider></v-divider>
                              <v-list dense style="max-height: 300px" class="overflow-y-auto">
                                <v-list-item-group v-if="wizard.formData.borrowKeys.length == 0" color="primary">
                                  <v-list-item>
                                    <p style="color:gray;">(None)</p>
                                  </v-list-item>
                                </v-list-item-group>
                                <v-list-item-group v-model="wizard.formData.selectedBorrowList" color="primary">
                                  <v-list-item v-for="(item, i) in wizard.formData.borrowKeys" :key="i">
                                    <v-list-item-icon>
                                      <v-icon>mdi-key</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                      <v-list-item-title>{{item.name}}</v-list-item-title>
                                      <v-list-item-subtitle>Space: {{item.spacesDisplay.toString().replace(/,/g, ", ")}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list-item-group>
                              </v-list>
                          </v-col>
                        </v-row>
                      </v-form>
                    <!-- </v-container> -->

                    <div class="wizard-actions">
                      <v-btn @click="wizard.step = 1">Back</v-btn>
                      <v-btn :disabled="wizard.formData.borrowKeys.length <= 0" class="ml-3" color="primary" @click="wizard.step = 3">Next</v-btn>
                    </div>
                </v-stepper-content>

                <v-stepper-content step="3">
                  <v-card class="mb-12"elevation="0">
                    <v-card-title>
                      Review
                    </v-card-title>

                    <v-card-text>
                      <h3>User</h3>
                      <v-divider></v-divider>
                      <v-row justify="space-between" v-if="wizard.formData.selectedUser">
                        <v-col col="1" md="1">
                          <v-icon x-large>mdi-account</v-icon>
                        </v-col>
                        <v-col col="11" md="11">
                          <div><h4>{{wizard.formData.selectedUser.id}}</h4></div>
                          <div>{{wizard.formData.selectedUser.email}}</div>
                          <div>{{wizard.formData.selectedUser.name}}</div>
                        </v-col>
                      </v-row>
                      <h3>Keys</h3>
                      <v-divider></v-divider>
                      <v-row justify="space-between">
                        <v-col col="1" md="1">
                          <v-icon x-large>mdi-key-chain</v-icon>
                        </v-col>
                        <v-col col="11" md="11">
                          <v-list dense>
                            <v-list-item-group color="primary">
                              <v-list-item v-for="(item, i) in wizard.formData.borrowKeys" :key="i">
                                <v-list-item-icon>
                                  <v-icon>mdi-key</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title><h4>{{item.name}}</h4></v-list-item-title>
                                  <v-list-item-subtitle>Space(s):
                                    <MitKeySpaces :dark="false" size="small" :spaces="item.spacesDisplay" :spacesDetails="item.spaces"/>
                                  </v-list-item-subtitle>
                                  <v-list-item-subtitle>Notes: {{item.data.notes}}</v-list-item-subtitle>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list-item-group>
                          </v-list>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>

                  <div class="wizard-actions">
                    <v-btn @click="wizard.step = 2">Back</v-btn>
                    <v-btn class="ml-3" color="primary" @click="wizardComplete">Finish</v-btn>
                  </div>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
            <v-card v-if="wizard.complete">
                <div v-if="wizard.loading">
                  <v-card-title>Loading...</v-card-title>
                  <v-card-text>
                      <v-col v-if="wizard.loading" class="d-flex justify-center align-center">
                        <v-row>
                          <MitLoading class="pa-10"/>
                        </v-row>
                      </v-col>
                  </v-card-text>
                </div>
                <div v-if="!wizard.loading && wizard.result.success">
                  <v-card-title><v-icon class="pr-5" color="success" x-large>mdi-check-circle</v-icon>Success</v-card-title>
                  <v-card-text>
                      Successfully checked out keys.
                  </v-card-text>
                </div>
                <div v-if="!wizard.loading && !wizard.result.success">
                  <v-card-title><v-icon color="error" x-large>mdi-alert-circle</v-icon>Error</v-card-title>
                  <v-card-text>
                  Sorry, an error occurred trying to borrow keys.
                  </v-card-text>
                  <div class="pb-10"> {{wizard.result.message}}</div>
                  <v-btn outlined color="primary" @click="tryAgain()">Try Again</v-btn>
                  <v-row align="center" justify="center">
                    <v-col cols="12">

                    </v-col>
                  </v-row>
                </div>
            </v-card>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import {MitEventBus} from '../../main.js';
  import MitLoading from '../../components/MitLoading.vue';
  import MitKeySpaces from '../../components/keys/MitKeySpaces.vue';

  import MitKeysService from '../../services/MitKeysService.js';
  import MitBorrowService from '../../services/MitBorrowService.js';
  import MitCSAILUsersService from '../../services/MitCSAILUsersService.js';
  import MitSpacesService from '../../services/MitSpacesService.js';

  export default {
    name: 'MitBorrowKeyPage',
    components: {
      MitLoading,
      MitKeySpaces
    },
    data: function() {
      return {
        valid: true,
        select: null,
        wizard:{
          step:1,//default step
          complete:false,
          loading:false,
          formData:
          {
              usersloading:false,
              userSearchTerm:'',
              keySearchTerm:'',
              selectedUser:'',
              selectedSpaces:[],
              selectedKeyList:[],
              selectedBorrowList:null,
              borrowKeys:[]
          },
          result:{
            success:false,
            message:''
          }
        },
        borrowModel:{
          owerId:null,
          keyId:null,
          data:{}
        },
        keyList:[],
        borrowList:[],
        userList: [],
        spaceList: [],
        currentBorrowedListHeaders:{
          items:[
                      {text: 'Name',align: 'start',sortable: true,value: 'keyName', width:'8%'},
                      {text: 'Type',sortable: false,value: 'type.name',width:'10%'},
                      {text: 'Borrowed Date',sortable: false,value: 'dates_local.checkoutDt',width:'12%'},
                      {text: 'Spaces',sortable: false,value: 'spaces',},
                ]
        },
        currentBorrowedList:{
          items:[]
        },
        dataTableNoText:''
      }
    },
    mounted() {

      MitKeysService.requestGetAvailableKeys()
        .then((keys) => {
          this.keyList = keys;
        })
        .catch((error) => {
          console.log('An error occurred trying to get keys list', error);
        });
    },
    computed: {
        userSearch: {
          get () {
            return this.wizard.formData.userSearchTerm
          },

          set (searchInput) {
            if (this.wizard.formData.userSearchTerm !== searchInput) {
              this.wizard.formData.userSearchTerm = searchInput
              this.getCsailUsers(this.wizard.formData.userSearchTerm);
            }
          }
        }
    },
    methods: {
      userSelectDataTableText(){
        //default text for the user select data table which shows current keys the user has.
        this.dataTableNoText = (this.currentBorrowedList.items.length === 0 && this.wizard.formData.userSearchTerm !== "") ? 'No keys borrowed.' : '';
      },
      userSelectInputChangeEvent(event){
        //cleared the user
        if(this.wizard.formData.userSearchTerm === ""){
          this.currentBorrowedList.items = [];
          this.userSelectDataTableText();
        }

      },
      userSelectedEvent(event){
        this.getBorrowedKeysForUser(event.id);
      },
      borrowKeys(userId, keys){
        let borrowModels = [];

        for(let key in keys){
          borrowModels.push({
            ownerId: userId,
            keyId: keys[key].id,
            data: {}
          });
        }

        return MitBorrowService.requestBorrowKeys(borrowModels);
      },
      getBorrowedKeysForUser(userId){
        if(typeof (userId) !== 'undefined' || userId !== null || userId.length > 0 ){
          MitBorrowService.requestGetBorrowedKeysByOwnerId(userId)
            .then((data) => {
              this.currentBorrowedList.items = data;
              this.userSelectDataTableText();
            })
            .catch((error) => {
              console.log('An error occurred trying to get keys list', error);
            });
        }
      },
      getCsailUsers(searchterm){
        this.wizard.formData.usersloading = true;
        MitCSAILUsersService.requestGetUsers(searchterm)
          .then((data) => {
            this.userList = data.users;
            this.wizard.formData.usersloading = false;
          })
          .catch((error) => {
            this.userList = [];
            this.wizard.formData.usersloading = false;
          });
      },
      toggleSelectedKey(isSelected,select,e) {
        select(!isSelected);
      },
      addToSelectedKeys(){
        this.wizard.formData.borrowKeys.push(this.wizard.formData.selectedKeyList[0]);
        this.keyList = this.keyList.filter( item => item.id !== this.wizard.formData.selectedKeyList[0].id );
        this.wizard.formData.selectedKeyList = [];
      },
      removeFromSelectedKeys(item){
        let key = this.wizard.formData.borrowKeys.splice(this.wizard.formData.selectedBorrowList, 1);
        this.keyList.push(key[0]);
      },
      wizardComplete(){
        this.wizard.complete = true;
        this.wizard.loading = true;

        this.borrowKeys(this.wizard.formData.selectedUser.id, this.wizard.formData.borrowKeys)
          .then((data) => {
            this.wizard.loading = false;
            this.wizard.result.success = true;
          })
          .catch((error) => {
            this.wizard.loading = false;
            this.wizard.result.message = 'An error occurred trying to borrow keys.';
            console.log('An error occurred trying to get keys list', error);
          });
      },
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .search-text {
    margin-top: -4px;
  }
  .search-type {
    max-width: 112px;
  }
  .mit-available-keys {
    margin-top: -20px;
  }
  .mit-selected-keys {
    margin-top: -10px;
  }
  .mit-row-selected {
    color: var(--v-primary-base);
    background-color: #E4EFFA;
    font-weight: bold;
    &:hover {
        background-color: #E4EFFA !important;
    }
  }
  .mit-app-loading-center {
    display: flex;
    align-items: center;
    justify-content: center;
    height:100vh;
  }
  .wizard-actions {
    padding-top: 20px;
  }
  .v-stepper__header {
    box-shadow: none;
  }
  .mit-info-card {
    width:100%;
    height:100%;
  }
</style>
